import * as Yup from 'yup'

export const cargoSchema = Yup.object().shape({
  codigo: Yup.string()
    .min(0, 'Mínimo de 0 caracteres.')
    .max(10, 'Máximo de 10 caracteres.')
    .notRequired(),
  nome: Yup.string().required('Nome do cargo é obrigatório'),
})
